import { LANGS } from "@/components/sections/header/nav-config";
import { getLangPillClass } from "@/lib/ui-helpers";

export default function LangSwitcher({ lang, setLang, variant = "desktop" }) {
  if (variant === "mobile") {
    return (
      <div className="flex items-center gap-2 pt-2">
        {LANGS.map(({ code, label }) => {
          const isActive = lang === code;
          const cls = isActive
            ? "bg-[var(--primary)] text-white"
            : "bg-[var(--bg)] text-[var(--muted)]";
          return (
            <button
              key={code}
              onClick={() => setLang(code)}
              data-testid={`mobile-lang-${code}`}
              className={`text-xs font-bold tracking-wider uppercase px-4 py-2.5 min-h-[44px] rounded-full ${cls}`}
            >
              {label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div
      className="hidden sm:flex items-center bg-[var(--bg)] rounded-full p-1 border border-[var(--border)]"
      data-testid="lang-switcher"
    >
      {LANGS.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={`lang-${code}`}
          className={`text-xs font-bold tracking-wider uppercase px-3 py-1.5 rounded-full transition ${getLangPillClass(code, lang)}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
